import React, { useState } from 'react';
import { useVoip } from '../voip/VoipProvider';
import useIsVoipUser from '../hooks/useIsVoipUser';
import '../assets/styles/voip-mic-permission-banner.less';

const VoipMicPermissionBanner = () => {
  const { microphonePermission } = useVoip() || {};
  const { isVoipUser } = useIsVoipUser();
  const [dismissed, setDismissed] = useState(false);

  if (!isVoipUser) return null;
  if (microphonePermission !== 'denied') return null;
  if (dismissed) return null;

  return (
    <div className="voip-mic-banner" role="alert">
      <div className="voip-mic-banner__content">
        <span className="voip-mic-banner__icon" aria-hidden="true">!</span>
        <div>
          <strong>Microphone access is blocked.</strong>
          <span className="voip-mic-banner__detail">
            &nbsp;Calls won&apos;t work until you allow microphone access in your browser&apos;s site settings, then refresh the page.
          </span>
        </div>
      </div>
      <button
        type="button"
        className="voip-mic-banner__close"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
};

export default VoipMicPermissionBanner;
